const ComplianceStatuses = [
    { id: 0, name: "No status", bgColor: "#d5d5d5", textColor: "black",},
    { id: 1, name: "In compliance", bgColor: "#48ca94", textColor: "white",},
    { id: 2, name: "In compliance – action required", bgColor: "#f7b204", textColor: "white",},
    { id: 3, name: "Partly in compliance", bgColor: "#f7b204", textColor: "white",},
    { id: 4, name: "Not in compliance", bgColor: "#d1153a", textColor: "white",},
    { id: 5, name: "New – in progress", bgColor: "#3398dc", textColor: "white", },
    { id: 6, name: "Archived", bgColor: "#888", textColor: "white", },
];


const SubmissionsStatuses = [
    { id: 0, name: "Preparation", bgColor: "#9dc3e6", textColor: "black", },
    { id: 1, name: "Submitted", bgColor: "#2e75b6", textColor: "white", },
    { id: 2, name: "Questions", bgColor: "#ffc000", textColor: "black", },
    { id: 3, name: "Completed", bgColor: "#548235", textColor: "white", },
];


const SubmissionsTypes = [
    { id: 0, name: "New", bgColor: "#aef1b5", textColor: "black", },
    { id: 1, name: "Renewal", bgColor: "#99d1f6", textColor: "black", },
    { id: 2, name: "Change", bgColor: "#ffd593", textColor: "black", },
    { id: 3, name: "Other", bgColor: "#e5e5e5", textColor: "black", },
];


const TechnicalDocumentationSectionStatus = {
    "Unchanged": 1,
    "Draft": 2,
    "Pending": 3,
    "Rejected": 4,
    "Approved": 5
};




export {
    ComplianceStatuses,
    SubmissionsStatuses,
    SubmissionsTypes,
    TechnicalDocumentationSectionStatus
};